import { createFileRoute, Navigate, redirect } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { AdminPageLayout } from "@/features/admin/components/AdminPageLayout";
import { TrainerProfilePage } from "@/features/admin/trainers/TrainerProfilePage";
import { fetchFeatureFlags } from "@/hooks/useFeatureFlags";
import { usePermissions } from "@/hooks/usePermissions";

export const Route = createFileRoute("/admin/trainers_/$userId")({
  // Trainers are hidden while the ilt flag is off (the API 404s them too).
  beforeLoad: async () => {
    const { ilt } = await fetchFeatureFlags();
    if (!ilt) throw redirect({ to: "/admin" });
  },
  component: TrainerProfileRoute,
  remountDeps: ({ params }) => params.userId,
});

/** One trainer's profile and performance (LMS-144); editable by admins with Courses.Manage. */
function TrainerProfileRoute() {
  const { userId } = Route.useParams();
  const { hasPermission } = usePermissions();

  return (
    <ProtectedRoute
      requiredPermissions={["Users.Read", "Analytics.Read"]}
      requiredRoles={["Admin"]}
    >
      {hasPermission("Users.Read") && hasPermission("Analytics.Read") ? (
        <AdminPageLayout mainClassName="bg-secondary_alt">
          <TrainerProfilePage userId={userId} />
        </AdminPageLayout>
      ) : (
        <Navigate to="/admin" />
      )}
    </ProtectedRoute>
  );
}
